import { postUrls, getUrls } from "./urls"
import http from "./http"

const Source = {
  submitContactRequest: payload => {
    return http(postUrls.clientLeadSubmit, "POST", payload)
  },
  getCookiePolicyViewed: () => {
    return http(getUrls.viewedCookiePolicy, "GET")
  },
  updateViewedCookiePolicy: (viewed_cookie_policy) => {
    return http(postUrls.updateViewedCookiePolicy, "POST", {viewed_cookie_policy})
  },
  brand: marketplaceName => http(`${getUrls.marketplaceTheme}?name=${marketplaceName}`, "GET"),
}

export { Source as default }



// WEBPACK FOOTER //
// ./src/common/Source.js